"use strict";

import angular from "angular";

const name = "splashScreen";
const factory = [
    "$window",
    function ($window) {
        return {
            restrict: "A",
            link: function (scope, iElement) {
                window.setTimeout(() => {
                    iElement.addClass("fade-out");
                    window.setTimeout(() => iElement.remove(), 500);
                }, 600);
            }
        };
    }
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
